import { render, staticRenderFns } from "./ManufacturerProductPerformanceDistributor.vue?vue&type=template&id=ae3f8954&"
import script from "./ManufacturerProductPerformanceDistributor.vue?vue&type=script&lang=js&"
export * from "./ManufacturerProductPerformanceDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports